<template>
	<header-menu-admin />
	
	<!-- Main Sections -->
	<main class="main-wrapper bg-lightest-gray">

		<!-- About Section Start -->
		<section class="about-section py-40">
			<div class="container-fluid">
				<div class="top-bar mb-16">
					<router-link :to="{path: '/admin/products'}" class="btn btn-secondary">
						Назад
					</router-link>
				</div>
				<div class="about-wrapper bg-white">
					<div class="about-block">
						<h4 class="mb-12">Добавление товара</h4>
						<form @submit.prevent="onProductAdd" class="contact-form">
							<div class="row">
								<div class="col-md-12">
									<div class="input-block mb-16">
										<label for="name" class="form-label">Название товара:</label>
										<input type="text" id="name" class="form-control" placeholder="Название товара" v-model="name" required>
									</div>
								</div>
								<div class="col-md-6">
									<div class="input-block mb-16">
										<label for="oldPrice" class="form-label">Старая цена товара:</label>
										<input type="number" id="oldPrice" @wheel="$event.target.blur()" class="form-control noscroll" min="1" v-model="oldPrice">
									</div>
								</div>
								<div class="col-md-6">
									<div class="input-block mb-16">
										<label for="price" class="form-label">Текущая цена товара:</label>
										<input type="number" id="price" @wheel="$event.target.blur()" class="form-control noscroll" min="1" v-model="price">
									</div>
								</div>
								<div class="col-md-12">
									<div class="input-block mb-16">
										<label for="category_id" class="form-label">Категория товара:</label>
										<select id="category_id" class="form-select" v-model="category_id" required>
											<option :value="cat.id" v-for="cat in appModel.productsCategories" :key="cat.id">{{cat.name}}</option>
										</select>
									</div>
								</div>
								<div class="col-md-12">
									<div class="input-block mb-16">
										<label for="description" class="form-label">Описание товара:</label>
										<textarea id="description" cols="8" rows="5" class="form-control" placeholder="Описание товара" v-model="description" required></textarea>
									</div>
								</div>
								<div class="col-md-12">
									<div class="input-block mb-16">
										<label for="poster" class="form-label">Постер:</label>
										<input type="file" id="poster" class="form-control d-block" @change="handleFileChange" required>
									</div>
								</div>
								<div class="col-md-12">
									<button type="submit" class="btn btn-primary" :disabled="btnDisabled">Добавить</button>
								</div>
							</div>
						</form>
						<div class="alert alert-warning alert-dismissible mt-3 mb-0" role="alert" v-if="error">
							{{error}}
							<button type="button" class="btn-close" aria-label="Close" @click="error = ''"></button>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- About Section End -->
	</main>
	<!-- Main Sections -->
</template>

<style lang="scss">
      
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import HeaderMenuAdmin from '@/components/HeaderMenuAdmin';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'InterMagTech Admin'});
	},
	data: () => ({
		category_id: '',
		name: '',
		oldPrice: '',
		price: '',
		description: '',
		poster: '',
		
		loading: true,
		error: '',
		btnDisabled: false,
	}),
	methods: {
		handleFileChange(event){
			this.poster = event.target.files[0];
		},
		async onProductAdd(){
			this.error = '';
			this.btnDisabled = true;
			
			const params = {
				category_id: this.category_id,
				name: this.name,
				oldPrice: this.oldPrice,
				price: this.price,
				description: this.description,
				poster: this.poster,
			};
			const ret = await this.appModel.doAddProduct(params);
			this.btnDisabled = false;
			if(ret.success){
				this.$router.push('/admin/products');
			} else {
				this.error = ret.error;
			}
		},
	},
	mounted(){
		window.scrollTo(0, 0);
	},
	beforeRouteUpdate(to, from, next){
		window.scrollTo(0, 0);
		next();
	},
	components: {
		HeaderMenuAdmin,
	},
};
</script>